export enum CheckStatus {
    UNCHECKED = 'unchecked',
    CHECKED = 'checked',
    INDETERMINATE = 'indeterminate',
}
